import { memo, useState } from "react";

import { Input } from "@buildpy/ui/input";
import { cn } from "@/lib/utils";
import { formatAmount, parseMoney, parseQty } from "@/modules/quote/ui/format";

interface Props {
  value: number;
  onCommit: (value: number) => void;
  /** money 는 정수·콤마, qty 는 소수 허용. */
  kind?: "money" | "qty";
  disabled?: boolean;
  ariaLabel: string;
  // 표 칸은 cell(기본) · 표 밖 단독 칸은 outline(늘 보이는 테두리).
  variant?: "cell" | "outline";
  className?: string;
  onBlur?: () => void;
}

/**
 * 숫자 칸. 포커스 중에는 사람이 친 문자열을 그대로 두고, 빠져나오면 콤마를 찍는다.
 * 포커스 중에도 포맷하면 "1,0" 처럼 커서가 튄다.
 */
const NumberField = ({
  value,
  onCommit,
  kind = "money",
  disabled,
  ariaLabel,
  variant = "cell",
  className,
  onBlur,
}: Props) => {
  const [draft, setDraft] = useState<string | null>(null);

  const display =
    draft ?? (value === 0 ? "" : kind === "money" ? formatAmount(value) : String(value));

  return (
    <Input
      aria-label={ariaLabel}
      className={cn("text-right tabular-nums", className)}
      disabled={disabled}
      inputMode={kind === "money" ? "numeric" : "decimal"}
      value={display}
      onBlur={() => {
        setDraft(null);
        onBlur?.();
      }}
      onChange={(e) => {
        const text = e.target.value;
        setDraft(text);
        onCommit(kind === "money" ? parseMoney(text) : parseQty(text));
      }}
      onFocus={(e) => e.currentTarget.select()}
      variant={variant}
    />
  );
};

export default memo(NumberField);
